import { sendCl } from '@/utils/logTrack'
import { isEmpty } from 'lodash'

function handleClick(el, binding) {
  const data = el.getAttribute('data-stats')
  if (typeof binding.value === 'boolean' && !binding.value) {
    return
  }
  const stats = typeof data === 'string' ? JSON.parse(data) : data
  if (isEmpty(data)) {
    console.warn('bury-click: data-stats is empty')
    return
  }
  sendCl(stats)
}

export default {
  mounted(el, binding) {
    el.addEventListener('click', handleClick.bind(null, el, binding), false)
  },
  update(el, binding) {
    el.removeEventListener('click', handleClick)
    el.addEventListener('click', handleClick.bind(null, el, binding), false)
  },
  unmounted(el) {
    el.removeEventListener('click', handleClick)
  }
}
